var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolanaLogo44X50 = function SvgSolanaLogo44X50(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56321"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68826",
    d: "M14.464 40.43a2.43 2.43 0 0 1 .48-1.27c-2.687-3.5-10.639-12.064-13.859-22.973 0 .003-6.742 10.077 13.379 24.243Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68827",
    d: "M17.484 37.524C6.363 12.967 10.298 4.273 10.298 4.273c-2.339.194-8.09 4.031-7.718 9.3.628 9.049 10.04 21.268 13.014 24.922a6.4 6.4 0 0 1 1.89-.971Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68828",
    d: "M21.524 36.897c.239 0 .477 0 .714.017.554-8.055 1.582-28.018 1.033-33.543-.585-5.852-9.508-2.995-10.871.389-3.854 9.575 3.787 28.445 5.988 33.5a13.522 13.522 0 0 1 3.136-.363Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68829",
    d: "M23.173 36.995a12.043 12.043 0 0 1 1.952.384c4.589-9.195 8.353-21.249 7.637-29.328-.628-7.083-7.852-6.825-7.852-6.825 1.024 10.329-1.088 30.134-1.737 35.769Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68830",
    d: "M34.496 6.945c1.148 11.6-6 26.418-8.295 30.819a5.211 5.211 0 0 1 1.549 1c4.508-6.4 10.511-13.5 12.1-22.034 1.298-7.064-5.354-9.785-5.354-9.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68831",
    d: "M41.222 16.19c-.647 8.42-9.4 19.187-12.945 23.237a2.357 2.357 0 0 1 .244.618C50.194 26.893 41.222 16.19 41.222 16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68832",
    d: "M21.525 37.914c-3.344 0-6.057 1.2-6.057 2.7a6.8 6.8 0 0 0 .466 2.654 5.511 5.511 0 0 0 .356.788 2.008 2.008 0 0 1 .32-.412 3.829 3.829 0 0 1 1.222-.771 9.766 9.766 0 0 1 3.7-.652 10.7 10.7 0 0 1 2.905.377 4.7 4.7 0 0 1 2.008 1.046 2.053 2.053 0 0 1 .322.42 5.648 5.648 0 0 0 .355-.788 6.813 6.813 0 0 0 .468-2.654c-.006-1.498-2.717-2.708-6.065-2.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68833",
    d: "M21.569 43.043c-2.566 0-4.647.616-4.647 1.377s2.081 1.377 4.647 1.377 4.647-.616 4.647-1.377-2.08-1.377-4.647-1.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68834",
    d: "M22.822 47.662a29.592 29.592 0 0 0-3.787-1.064c-.4-.043-1.052.052-1.052.833s.654 2.649 4.245 2.565c1.532-.034 2.4-.387 2.6-.86s-.145-.697-2.006-1.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68835",
    d: "m20.882 46.766 3.4 1.112s.821.244 1.033-.288.241-1.119-.64-1.176-5.888-.335-3.793.352Z"
  }))));
};
export default SvgSolanaLogo44X50;